import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import icon from '../../../assets/chevron-down.svg';
import iconWhite from '../../../assets/chevron-down-white.svg';

export const FilterLocation = styled.div`
  display: ${({ mobile }) => (mobile ? 'none' : 'inline-block')};
  position: relative;
  max-width: 100%;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin: 6px 0;
  background: ${({ theme, selected }) =>
    (selected
      ? `url(${iconWhite}) center right no-repeat ${theme.mainColor}`
      : `url(${icon}) center right no-repeat #fff`)};
  color: ${({ theme, selected }) => (selected ? '#fff' : theme.colors.font)};
  ${({ selected }) =>
    (selected
      ? `
      ${fontSmoothing}
      `
      : null)};

  select {
    padding: 6px 42px 6px 15px;
    cursor: pointer;
    ${getFont(0)};
    color: currentColor;

    ${maxMediaQueries.phablet`
      display: block;
      width: 100%;
    `};

    ::-ms-expand {
      display: none;
    }
  }

  option {
    color: ${({ theme }) => theme.colors.font};
  }

  ${maxMediaQueries.tablet`
    display: ${({ mobile }) => (mobile ? 'inline-block' : 'none')};
  `};

  ${maxMediaQueries.phablet`
    width: 100%;
  `};
`;
